<template>
  <div style="height: 100%;background: #fff">
    <div v-if="noData == 'false'">
      <!--头部开始 -->
      <top-part />
      <!-- 头部结束 -->
      <div class="content" :class="{'bottom-site': welfareDetail.free1 =='统一生日慰问'}">
        <div class="welfareDetail" v-loading.fullscreen.lock="loading">
          <!-- 福利状态信息开始 -->
          <div>
            <p class="welfare-header">
              <span
                class="welfare-status-btn"
                :class="gianClass(defineStatus)"
              >{{welfareDetail.welStatus}}</span>
              <span class="welfare-text1">{{welfareDetail.welfareName}}</span>
            </p>
            <p>
              <span class="welfare-mianPart">主办单位</span>
              <span class="welfare-mianPart welfare-text2">{{welfareDetail.hostUnit}}</span>
            </p>
            <p>
              <span class="welfare-mianPart">领取时间</span>
              <span
                class="welfare-mianPart welfare-text2"
              >{{welfareDetail.beginTime}}至{{welfareDetail.endTime}}</span>
            </p>
            <p>
              <span class="welfare-mianPart">生日慰问类型</span>
              <span
                class="welfare-mianPart welfare-text2 welfare-text-active"
              >{{welfareDetail.free1}}</span>
            </p>
          </div>
          <!-- 福利状态信息结束 -->

          <!-- 自选福利商品开始 -->
          <div
            class="own-select-box"
            v-if="welfareDetail.free1 =='自选生日慰问' || welfareDetail.productEntity && welfareDetail.productEntity.length !=0"
          >
            <p class="welfare-mianPart">生日慰问商品</p>
            <van-grid square :column-num="3" :border="false" icon-size="2rem">
              <van-grid-item
                v-for="(item,index) in welfareDetail.productEntity"
                :key="index"
                :icon="item.mainImageSrc"
                :text="item.productName"
              />
            </van-grid>
          </div>
          <!-- 自选福利商品结束 -->

          <!-- 统一发放福利开始 -->
          <div v-if="welfareDetail.content">
            <!-- <div class="sino-welfare-title">{{welfareDetail.welfareName}}</div> -->
            <div class="sino-welfare-title">生日慰问介绍</div>
            <div class="sino-welfare-content">
              <div v-html="welfareDetail.content" class ref="fold"></div>
              <!-- <div class="welfare-content">
              所有福利活动、都是以分会为单位报名。常规的活动
              动或比赛有跳绳、踢毽、拔河
            </div>
            <template>
              <div class="welfare-list">
                <img class="wf-img" src="@/images/doctor.png" />
                <span>1、一箱鸡蛋</span>
              </div>
              <div class="welfare-list">
                <img class="wf-img" src="@/images/doctor.png" />
                <span>1、一箱鸡蛋</span>
              </div>
              </template>-->
            </div>
          </div>
          <!-- 统一发放福利结束 -->
          <!-- 自选福利开始 -->
          <div style="display: none">
            <div class="sino-welfare-title">如何兑换</div>
            <div>
              <p class="welfare-ownSelect-text">1.访问智慧工会系统，在首页找到“普惠专区” 点击进入浏览慰问品套餐</p>
              <div class="welfare-ownSelect-area">
                <p class="sino-welfare-title">关爱/职工权益</p>
                <!-- <img src='@/images/index_icon1.png'> -->
                <van-grid :border="false" icon-size="42px">
                  <!-- <van-grid-item  text="工会福利" to="/welfareNew">
                  <van-image src="@/images/index_icon1.png" />
                  </van-grid-item>-->
                  <van-grid-item
                    :icon="require('@/images/index_icon1.png')"
                    text="工会节日慰问"
                    to="/welfareNew"
                  />
                  <van-grid-item
                    :icon="require('@/images/index_icon2.png')"
                    text="工会活动"
                    to="/activity"
                  />
                  <van-grid-item
                    :icon="require('@/images/index_icon3.png')"
                    text="普惠商城"
                    to="/shoppingMall"
                  />
                </van-grid>
              </div>
              <p class="welfare-ownSelect-text">
                2.慰问品共分3个套餐，可任选其一进行兑换，兑换过程中填写快递地址，待兑换活动结束后统一按照快递地址配送。
                <i
                  class="exchange-text"
                >兑换期间未兑换的会员，将默认选中A套餐</i>
              </p>
            </div>
          </div>
          <!-- 自选福利结束 -->
          <div v-if="welfareDetail.free1 =='统一生日慰问'" :class="{'topHandle':!welfareDetail.content}">
            <div class="sino-detail-footer" v-if="roleCode == '3'">
              <div class="img-block">
                <img
                  v-if="welfareDetail.signature"
                  class="sign-img"
                  :src="welfareDetail.signature"
                  alt
                  srcset
                />
              </div>
              <div>
                <div v-if="welfareDetail.signature" class="save-btn-disabled">已领取</div>
                <div
                  v-else
                  :class="[!welfareDetail.signature && isReceive ? 'save-btn':'save-btn-disabled']"
                  @click="showPopup('myPopup')"
                >确认领取并签名</div>
              </div>
            </div>
            <div class="sino-detail-footer" v-else>
              <div class="img-block">
                <img
                  v-if="welfareDetail.signature"
                  class="sign-img"
                  :src="welfareDetail.signature"
                  alt
                  srcset
                />
              </div>
              <div>
                <div v-if="welfareDetail.signature" class="save-btn-disabled">已领取</div>
                <div
                  v-else
                  :class="[!welfareDetail.signature && isReceive && receivingStatus=='1'? 'save-btn':'save-btn-disabled']"
                  @click="showPopup('zg')"
                >确认领取并签名</div>
              </div>
            </div>
          </div>
          <div
            @click="goShoppingMall"
            :class="{'exchange-default':defineStatus !='1'}"
            v-else
            class="exchange-btn"
          >{{btnText}}</div>
          <div v-show="showSin" style="position:fixed;top:0" v-loading="loading">
            <signature @closePop="closePop" @saveImg="upload"></signature>
          </div>
        </div>
      </div>
    </div>
    <page-none v-if="noData =='true'" />
  </div>
</template>
<script type="text/ecmascript-6">
import { getAppWelfareDetails, signupWelfareSignature } from "@/common/api";
import { toast } from "@/common/api/api.js";
import signature from "../../components/signature.vue";
import moment from "moment";
import topPart from "../../components/topPart";
import pageNone from "../../components/pageNone";

import Vue from "vue";
import { Grid, GridItem } from "vant";

Vue.use(Grid);
Vue.use(GridItem);
export default {
  data() {
    return {
      welfareId: "",
      free1: this.$route.query.welfareId, //福利类型
      status: "1",
      welfareDetail: {},
      loading: false,
      showSin: false,
      isReceive: false,
      receivingStatus: "",
      roleCode: JSON.parse(localStorage.loginInfo).identity,
      defineStatus: this.$route.query.status, //福利状态
      welfareState: {
        //福利状态
        "0": "未开始",
        "1": "进行中",
        "2": "已结束"
      },
      welFareFree1: {
        //福利类型
        "1": "统一生日慰问",
        "2": "自选生日慰问"
      },
      btnText: "兑换已结束", //button文案
      noData: ""
    };
  },
  components: {
    signature,
    topPart,
    pageNone
  },
  created() {
    this.welfareId = this.$route.query.welfareId;
    this.getWelfareDetails(this.welfareId);
    console.log('status',this.$route.query.status)
    // this.status = this.$route.query.status == 0 ? "1" : "0";
  },
  mounted() {},
  methods: {
    // 判断自选福利的商品兑换状态，改变兑换button文案
    exchangeBtnText(item, status) {
      if (status != 2) {
        if (item == 0) {
          this.defineStatus = "3";
        }
      }
    },
    // 福利的状态样式
    gianClass(state) {
      return state == "2" ? "status-end" : state == "0" ? "status-wait" : "";
    },
    // 根据状态改变button的文案
    changeText() {
      if (this.defineStatus == "1") {
        //可以进行兑换的状态
        this.btnText = "立即兑换";
      } else if (this.defineStatus == "3") {
        this.btnText = "已兑换";
      } else {
        this.btnText = `兑换${this.welfareDetail.welStatus}`;
      }
    },
    // 跳转普惠商城
    goShoppingMall() {
      if (this.defineStatus != "1") {
        // toast(this, "抱歉，该福利已结束", "error");
        return;
      }
      let welfareId = this.welfareId;
      this.$router.push({
        path: "/shoppingMall",
        query: {
          welfareId,
          welfareCategory:'1'
        }
      });
    },
    // 把后端传来的数据进行转换
    eachangeName(item) {
      console.log('处理数据',item)
      item.free1 = this.welFareFree1[item.free1]; // 把福利的福利类型从后端传来的value转为name
      item.welStatus = this.welfareState[this.defineStatus]; // 把福利的福利类型从后端传来的value转为name
      item.beginTime = moment(item.beginTime).format("YYYY-MM-DD HH:mm:ss"); // 把开始时间格式化
      item.endTime = moment(item.endTime).format("YYYY-MM-DD HH:mm:ss"); // 把结束时间格式化
    },
    // 获取福利详情
    getWelfareDetails() {
      this.loading = true;
      getAppWelfareDetails({
        welfareId: this.$route.query.welfareId,
        unionId: JSON.parse(localStorage.loginInfo).unionId,
        welfareCategory:'1'
      }).then(res => {
        if (res.code == 200) {
          this.noData = "false";
          this.loading = false;
          if (res.data[0].content) {
            res.data[0].content = res.data[0].content
              .replace(new RegExp("&lt;", "g"), "<")
              .replace(new RegExp("&quot;", "g"), "")
              .replace(new RegExp("&gt;", "g"), ">");
          }
          this.welfareDetail = res.data[0];
          this.eachangeName(this.welfareDetail);
          let beginTime =  this.welfareDetail.beginTime; 
          let endTime =  this.welfareDetail.endTime;
          console.log(this.welfareDetail);
          let currentTime = moment().format("YYYY-MM-DD HH:mm:ss");
          if (beginTime <= currentTime && endTime >= currentTime) { //时间判断问题
            this.isReceive = true;
          }
          if (JSON.parse(localStorage.loginInfo).roleCode != "3") {
            this.receivingStatus = res.data[0].receivingStatus;
          }
          this.exchangeBtnText(
            res.data[0].exchangeStatus,
            res.data[0].statusFlag
          );
          this.changeText();
        } else {
          this.loading = false;
          this.noData = "true";
          // toast(this, res.message, "error");
          setTimeout(() => {
            // this.$router.go(-1);
          }, 1000);
        }
      });
    },

    showPopup(type) {
      if (type == "zg") {
        if (
          !this.welfareDetail.signature &&
          this.isReceive &&
          this.receivingStatus == "1"
        ) {
          this.showSin = true;
        }
      } else {
        if (!this.welfareDetail.signature && this.isReceive) {
          this.showSin = true;
        } else {
          // toast(this,"此福利您已领取,无法重复领取",'error')
          return;
        }
      }
    },
    closePop() {
      this.showSin = false;
    },
    upload(data) {
      if (!data) {
        toast(this, "请完成签名后领取", "error");
      } else {
        this.loading = true;
        signupWelfareSignature({
          welfareId: this.welfareDetail.welfareId,
          signatureFile: data,
           welfareCategory:'1'
        }).then(res => {
          if (res.code == 200) {
            toast(this, "已领取生日慰问!");
            this.showSin = false;
            this.loading = false;
            this.getWelfareDetails();
          } else {
            toast(this, res.message, "error");
            this.loading = false;
          }
        });
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "greetings") {
      next({ name: "home", query: { label: "生日慰问领取" } });
    } else {
      next();
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../assets/stylus/common.styl';
@import '../../assets/stylus/theme.styl';

.welfareDetail .sino-detail-footer {
  position: fixed;
  bottom: 0;
}

.content {
  myContent();
  background: #fff;
  bottom: 60px;
}

.bottom-site {
  bottom: 149px;
}

.topHandle {
  margin-top: 250px;
}

.own-select-box {
  margin-bottom: 28px;
}

.own-select-box >>> .van-icon__image {
  width: 100px;
}

.own-select-box >>> .van-grid-item__content {
  padding: 10px;
}

.own-select-box >>> .van-grid-item {
  padding-top: 23% !important;
}

.own-select-box >>> .van-grid-item__text {
  margin-top: 0;
}

.exchange-btn {
  background: #29bebc;
  border-radius: 5px;
  color: #fff;
  text-align: center;
  padding: 11px 0;
  width: 90%;
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  margin: auto;
}

.exchange-default {
  background: #CACAD2;
}

.welfare-header {
  padding: 10px 0;
}

.welfare-status-btn {
  width: 44px;
  height: 20px;
  background: linear-gradient(103deg, rgba(255, 19, 86, 1), rgba(255, 59, 142, 1), rgba(255, 19, 86, 1));
  border-radius: 4px;
  color: #fff;
  font-size: 11px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  display: inline-block;
  text-align: center;
  line-height: 20px;
  vertical-align: text-bottom;
  margin-right: 8px;
}

.status-end {
  background: #000000;
  opacity: 0.5;
  border-radius: 4px;
}

.status-wait {
  background: linear-gradient(#4FACFE, #00F2FE);
  border-radius: 4px;
}

.welfare-text1 {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(53, 53, 53, 1);
}

.welfare-mianPart {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(146, 156, 175, 1);
  line-height: 25px;
}

.welfare-text2 {
  color: #353535;
  margin-left: 10px;
}

.welfare-text-active {
  color: $main-bgColor;
}

// 自选福利样式
.welfare-ownSelect-text {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(53, 53, 53, 1);
  line-height: 27px;
}

.welfare-ownSelect-area {
  box-shadow: 1px -1px 2px #e5e5e5, 1px -1px 2px #e5e5e5, -1px 1px 2px #e5e5e5, -1px -1px 2px #e5e5e5;
  border-radius: 10px;
  padding: 5px 10px 0;
  margin: 10px 0;
}

.exchange-text {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FF4B4B;
  line-height: 27px;
}

.welfareDetail {
  height: 100%;
  background: #fff;
  padding: 0 10px;

  .sino-welfare-title {
    // height: 50px;
    line-height: 40px;
    font-size: 22px;
    font-weight: 700;
    color: rgba(53, 53, 53, 1);
    white-space: nowrap;
    display: inline-block;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
  }

  .sino-welfare-content >>> img {
    width: 100%;
  }

  .sino-welfare-content {
    // max-height: calc(100% - 226px);
    overflow: auto;
    margin-bottom: 25px;
    line-height: 20px;
    font-size: 14px;

    img {
      width: 100%;
    }

    .html {
      color: #888;
      margin-bottom: 10px;
      line-height: 28px;
      padding: 0 10px;
      font-size: 14px;
    }

    .welfare-content {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(136, 136, 136, 1);
      line-height: 0.7rem;
      margin-bottom: 10px;
    }

    .welfare-list {
      color: #353535;
      font-size: 0.36rem;
      font-family: PingFang SC;
      font-weight: 400;
      text-align: center;

      .wf-img {
        width: 1.9rem;
        border-radius: 8px;
        margin-right: 0.36rem;
      }
    }

    .sino-fold-btn {
      margin-right: 10px;
    }
  }

  .sino-detail-footer {
    text-align: center;
    width: 100%;
    margin: 10px 0 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .save-btn {
      width: 190px;
      height: 52px;
      line-height: 52px;
      display: inline-block;
      text-align: center;
      background: linear-gradient(0deg, rgba(12, 212, 183, 1), rgba(61, 212, 243, 1));
      border-radius: 52px;
      font-size: 20px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      border-radius: 26px;
    }

    .save-btn-disabled {
      width: 190px;
      height: 52px;
      line-height: 52px;
      display: inline-block;
      text-align: center;
      background: linear-gradient(0deg, rgba(61, 212, 243, 0.5), rgba(12, 212, 183, 0.5));
      border-radius: 52px;
      font-size: 20px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }

    .img-block {
      width: 290px;
      height: 74px;
      background: rgba(243, 245, 248, 1);
      border-radius: 2px;
      margin-bottom: 10px;
      display: flex;
      justify-content: center;
      align-items: center;

      .sign-img {
        width: 70px;
        transform: rotate(90deg);
      }
    }
  }
}
</style>
